<template>
  <div class="hello">

      <!-- Sending emails -->
        <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Sending emails...</p>
            </div>
        </transition>


        <!-- No users selected error -->
        <b-modal no-fade id='modal-nousers' title="No Buyers Selected" ok-only header-bg-variant='info' header-text-variant="light">
            Must select at least one buyer
        </b-modal>


    <b-container>
        

        <b-row style="margin-top:20px; margin-bottom:10px">
            <b-col>
                <h4>Select Buyers</h4>
            </b-col>
        </b-row>


        <!-- Manually entered emails -->
        <h6 style="margin-top:20px">(Optional) Enter more emails, separated by commas</h6>
        <b-form-group 
            class="mb-0"
            label-for="textarea-formatter-delivery"
            description="Emails, separated by commas"
            >
            <b-form-textarea
                id="textarea-formatter-delivery"
                v-model="manualEmails"
                placeholder="Emails, separated by commas"
            ></b-form-textarea>
        </b-form-group>

        <!-- Show buyers list -->
        <b-row style="margin-top:20px">
            <b-col>
                <h4>Your email will go to:</h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <table class="table table-striped" style="margin-left:50px; margin-right:50px">
                    <thead class="thead-dark">
                        <tr>
                            <th>
                                Select
                            </th>
                            <th>
                                Name
                            </th>
                            <th>
                                Address
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="theBuyer in buyersList">
                            <tr :key="theBuyer.company">
                                <!-- Button to select unselect -->
                                <td>
                                    <b-button v-if="!theBuyer.selected" variant="outline-secondary" @click="selectBuyer(theBuyer.uid)" style="height:40px; width:40px">
                                    </b-button>
                                    <b-button v-else variant="outline-secondary"  style="height:40px; width:40px" @click="unSelectBuyer(theBuyer.uid)">
                                        <font-awesome-icon icon="check-square" />
                                    </b-button>
                                </td>
                                <!-- Name -->
                                <td>{{theBuyer.company}}</td>
                                <!-- Address -->
                                <td>{{theBuyer.address}}</td>

                            </tr>
                        </template>
                    </tbody>
                </table>
            </b-col>
        </b-row>
                
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')

export default {    
    
    props: ['counties'],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'userInventory',]),

    },

    components: {
    },

    data() {
        return {
            buyersList:[],
            manualEmails:'',
            performingRequest:false,
        }
    },

    methods:{
        //Get buyers
        getBuyers(){
            this.buyersList = []
            var buyersArray=[]
            fb.usersCollection.where("county", "in", this.$store.state.brewerEmailsStore.countiesForEmail).where("state", "==", this.userProfile.state).where("isbrewer", "==", 0).get().then(docs => {
                docs.forEach(doc => {
                    var theBuyerData = doc.data()
                    var theBuyerId = doc.id
                    var theBuyerName = theBuyerData.company
                    var theBuyerEmail = theBuyerData.email
                    var theBuyerUid = theBuyerData.uid
                    //Create address
                    var address = theBuyerData.street1
                    if (theBuyerData.street2) address = address + ", " + theBuyerData.street2
                    address = address + ", " + theBuyerData.city + ', ' + theBuyerData.state  + " "  + theBuyerData.zip 
                    var buyerObject = {
                        company: theBuyerName,
                        email: theBuyerEmail,
                        uid: theBuyerId,
                        selected:true,
                        address:address,
                    }

                    //Add only if unsubscribeBrewerEmails != 1
                    if('unsubscribebrewer' in theBuyerData){
                        if (theBuyerData.unsubscribebrewer==1){
                            //Skip
                        }
                        //User allowed emails
                        else {
                            buyersArray.push(buyerObject)
                        }
                    }
                    //Allow email field doesn't exit
                    else{
                        buyersArray.push(buyerObject)
                    }

                    })
                }).then(res => {
                    this.buyersList = buyersArray
                    })
        },

        //Unselect a buyer
        unSelectBuyer(uid){
            const existingBuyerindex = this.buyersList.findIndex(item => item.uid === uid);
            if (existingBuyerindex>-1){
                var theBuyer = this.buyersList[existingBuyerindex]
                theBuyer.selected = false
                this.buyersList.splice(existingBuyerindex, 1, theBuyer)
            }

        },

        //Select buyer
        selectBuyer(uid){
            const existingBuyerindex = this.buyersList.findIndex(item => item.uid === uid);
            if (existingBuyerindex>-1){
                var theBuyer = this.buyersList[existingBuyerindex]
                theBuyer.selected = true
                this.buyersList.splice(existingBuyerindex, 1, theBuyer)
            }

        },


    },

    mounted(){
        //Get manual emails
        if (this.userProfile.manualEmails) this.manualEmails = this.userProfile.manualEmails
        this.getBuyers()
    },
}
</script>


